const statusReportKey = '/status-report';

export const statusReport = () => {
  return statusReportKey;
};
